import { SVGProps } from 'react';

export const RotateClockwiseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="14" height="14" viewBox="0 0 155 157" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="42" y="81.2708" width="106" height="68" rx="19" stroke="currentColor" strokeWidth="14" />
      <path
        d="M7 114.271L7 86.7708C7 42.7708 23.5 28.2708 66 28.2708H103"
        stroke="currentColor"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <path
        d="M139.927 21.9573C145.004 25.0812 145.004 32.4604 139.927 35.5842L106.193 56.3423C100.862 59.6221 94 55.7873 94 49.5289V8.01263C94 1.75419 100.862 -2.08063 106.193 1.1992L139.927 21.9573Z"
        fill="currentColor"
      />
    </svg>
  );
};
